import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import styles from './LegalPages.module.css';

function CookiePolicy() {
  return (
    <>
      <SEO
        title="Cookie Policy"
        description="Cookie Policy for Sapienta VC website and services."
        canonical="https://sapienta.vc/cookie-policy"
      />
      <div className={styles.container}>
      <p className={styles.effectiveDate}>Effective Date: 07/11/2025</p>

      <p className={styles.text}>
        Sapienta ("we", "our", or "us") is a holding company group of ventures that operates a variety of websites and digital platforms. This Cookie Policy explains how we use cookies and similar tracking technologies across our sites and services, how you can manage them, and the choices available to you regarding their use.
      </p>

      <div className={styles.section}>
        <h2 className={styles.subHeading}>1. What are Cookies?</h2>
        <p className={styles.text}>
          Cookies are small text files that are placed on your device when you visit a website or use an app. They are used to make websites work more efficiently, enhance the user experience, and provide us with important information about how our sites are used.
        </p>
      </div>

      <div className={styles.section}>
        <h2 className={styles.subHeading}>2. Types of Cookies We Use</h2>
        <p className={styles.text}>
          We use the following types of cookies on our websites and digital platforms:
        </p>
        <ul className={styles.list}>
          <li className={styles.listItem}>
            <strong>Essential Cookies:</strong> These cookies are necessary for the functioning of our websites. Without them, the website cannot function properly. They are typically set in response to actions made by you, such as logging in or completing forms.
          </li>
          <li className={styles.listItem}>
            <strong>Performance Cookies:</strong> These cookies collect information about how visitors use our websites, including which pages are visited most often and whether users get error messages. These cookies help us improve the performance and functionality of our sites.
          </li>
          <li className={styles.listItem}>
            <strong>Functional Cookies:</strong> These cookies allow our websites to remember your preferences (such as language, region, or other settings) to improve your experience.
          </li>
          <li className={styles.listItem}>
            <strong>Targeting/Advertising Cookies:</strong> These cookies are used to deliver advertisements that are more relevant to you and your interests. They track your browsing habits across different websites to provide personalized advertising.
          </li>
          <li className={styles.listItem}>
            <strong>Third-Party Cookies:</strong> In some cases, we may allow third-party service providers (such as analytics providers, advertisers, or social media platforms) to set cookies on your device. These cookies are subject to the privacy policies of those third parties.
          </li>
        </ul>
      </div>

      <div className={styles.section}>
        <h2 className={styles.subHeading}>3. How We Use Cookies</h2>
        <p className={styles.text}>
          Cookies help us improve your experience on our websites and digital platforms by enabling us to:
        </p>
        <ul className={styles.list}>
          <li className={styles.listItem}>Remember your preferences and settings.</li>
          <li className={styles.listItem}>Analyze usage data to improve the design and performance of our sites.</li>
          <li className={styles.listItem}>Deliver relevant content, including advertisements, tailored to your interests.</li>
          <li className={styles.listItem}>Track interactions across multiple devices and platforms for consistency.</li>
        </ul>
      </div>

      <div className={styles.section}>
        <h2 className={styles.subHeading}>4. Managing and Controlling Cookies</h2>
        <p className={styles.text}>
          You have the right to control whether cookies are placed on your device. You can manage cookie settings through your browser preferences or by using cookie management tools provided on our websites.
        </p>
        <p className={styles.text}>
          To disable cookies, you can:
        </p>
        <ul className={styles.list}>
          <li className={styles.listItem}>
            <strong>Adjust your browser settings:</strong> Most browsers allow you to control cookies through their settings (such as blocking all cookies or accepting them only from certain sites).
          </li>
          <li className={styles.listItem}>
            <strong>Use our cookie preferences tool:</strong> We provide a cookie banner or tool that allows you to manage your cookie preferences when you visit our websites.
          </li>
        </ul>
        <p className={styles.text}>
          Please note that disabling cookies may affect the functionality of some parts of our sites, and you may not be able to use all features or services.
        </p>
      </div>

      <div className={styles.section}>
        <h2 className={styles.subHeading}>5. Third-Party Cookies</h2>
        <p className={styles.text}>
          Our websites may contain links to third-party websites or services that may set their own cookies. These third-party cookies are not under our control, and we encourage you to review the privacy and cookie policies of these third parties for more information on how they use cookies.
        </p>
      </div>

      <div className={styles.section}>
        <h2 className={styles.subHeading}>6. Data Protection and Privacy</h2>
        <p className={styles.text}>
          The data collected through cookies may be subject to local data protection laws, including the General Data Protection Regulation (GDPR) in the European Union and the California Consumer Privacy Act (CCPA) in the United States. For more information on how we protect your data and respect your privacy, please refer to our <Link to="/privacy-policy" className={styles.link}>Privacy Policy</Link> page.
        </p>
      </div>

      <div className={styles.section}>
        <h2 className={styles.subHeading}>7. Updates to This Cookie Policy</h2>
        <p className={styles.text}>
          We may update this Cookie Policy from time to time to reflect changes in our practices or to comply with legal requirements. We encourage you to review this policy periodically for any updates. The date of the most recent revision will be indicated at the top of this page.
        </p>
      </div>

      <div className={styles.section}>
        <h2 className={styles.subHeading}>8. Contact Us</h2>
        <p className={styles.text}>
          If you have any questions or concerns about our use of cookies or this policy, please contact us at:
        </p>
        <p className={styles.text}>
          <strong>Sapienta Group of Ventures</strong><br />
          Email: legal@sapienta.vc<br />
          Address: 3811 Ditmars Blvd<br />
          Astoria, NY 11105-1803, US
        </p>
      </div>
    </div>
    </>
  );
}

export default CookiePolicy; 